import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ValuationProcessAdjustmentsState, adapter } from "../_reducers/valuation-adjustment.reducer";

const { selectAll } = adapter.getSelectors()

const selectValuationProcessAdjustmentsState = createFeatureSelector<ValuationProcessAdjustmentsState>('valuation-process-adjustments')
export const selectValuationProcessAdjustments = createSelector(
    selectValuationProcessAdjustmentsState,
    selectAll
)